import { render, staticRenderFns } from "./Bidding.vue?vue&type=template&id=c567caa2"
import script from "./Bidding.vue?vue&type=script&lang=js"
export * from "./Bidding.vue?vue&type=script&lang=js"
import style0 from "./Bidding.vue?vue&type=style&index=0&id=c567caa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports